import { render, staticRenderFns } from "./OrcidPublications.vue?vue&type=template&id=45d34255&scoped=true&"
import script from "./OrcidPublications.vue?vue&type=script&lang=js&"
export * from "./OrcidPublications.vue?vue&type=script&lang=js&"
import style0 from "./OrcidPublications.vue?vue&type=style&index=0&id=45d34255&scoped=true&lang=scss&"
import style1 from "./OrcidPublications.vue?vue&type=style&index=1&id=45d34255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d34255",
  null
  
)

export default component.exports